import { render, staticRenderFns } from "./ed-pagination-footer.component.vue?vue&type=template&id=1a91a6d6&scoped=true&"
import script from "./ed-pagination-footer.component.ts?vue&type=script&lang=ts&"
export * from "./ed-pagination-footer.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-pagination-footer.component.scss?vue&type=style&index=0&id=1a91a6d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a91a6d6",
  null
  
)

export default component.exports